module.exports = __webpack_public_path__ + "media/icons/mp3@3x-c2bde7c8.svg";